<ng-template #filePreviewTemplate>
  <div class="tw-flex tw-h-full tw-p-2 tw-w-full">
    <!-- Mapped statement preview: shown once the column-mapping dialog confirms. -->
    <div *ngIf="hasMappedRows; else rawPreview" class="tw-flex tw-h-full tw-w-full tw-flex-col">
      <div class="preview-grid-scroll tw-w-full tw-flex-1">
        <table class="preview-grid tw-w-full">
          <thead>
            <tr>
              <th>{{ "date" | i18n }}</th>
              <th>{{ "description" | i18n }}</th>
              <th class="tw-text-right">{{ "amount" | i18n }}</th>
              <th>{{ "type" | i18n }}</th>
              <th *ngIf="showMappedCategory">{{ "category" | i18n }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let row of visibleMappedRows; trackBy: trackByIndex"
              [class.tw-bg-danger-100]="!row.valid"
            >
              <td>{{ row.valid ? row.date : row.rawDate }}</td>
              <td>{{ row.description }}</td>
              <td class="tw-text-right">{{ row.amount }}</td>
              <td>{{ row.type }}</td>
              <td *ngIf="showMappedCategory">{{ row.category }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p *ngIf="mappedTruncated" class="tw-pt-1 tw-text-xs tw-text-dt-neutral-600">
        {{ "previewShowingFirst" | i18n: previewRowCap : totalMappedRows }}
      </p>
    </div>

    <!-- Spreadsheet-style preview for csv / xls / xlsx (one tab per worksheet) -->
    <ng-template #rawPreview>
      <ng-container *ngIf="isTabular; else nonTabular">
        <p *ngIf="previewError">{{ "filePreviewNotAvailable" | i18n }}</p>
        <div
          *ngIf="!previewError && activeSheet as sheet"
          class="tw-flex tw-h-full tw-w-full tw-flex-col"
        >
          <div class="preview-grid-scroll tw-w-full tw-flex-1">
            <table class="preview-grid">
              <thead>
                <tr>
                  <th class="row-index">#</th>
                  <th *ngFor="let header of sheet.grid.headers; trackBy: trackByIndex">
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of visibleSheetRows; let i = index; trackBy: trackByIndex">
                  <td class="row-index">{{ i + 1 }}</td>
                  <td
                    *ngFor="let header of sheet.grid.headers; let c = index; trackBy: trackByIndex"
                  >
                    {{ row[c] }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p *ngIf="sheetTruncated" class="tw-pt-1 tw-text-xs tw-text-dt-neutral-600">
            {{ "previewShowingFirst" | i18n: previewRowCap : totalSheetRows }}
          </p>
          <div class="sheet-tabs" *ngIf="sheets.length > 1">
            <button
              type="button"
              class="sheet-tab"
              *ngFor="let s of sheets; let i = index"
              [class.active]="i === activeSheetIndex"
              (click)="selectSheet(i)"
            >
              {{ s.name }}
            </button>
          </div>
        </div>
      </ng-container>

      <ng-template #nonTabular>
        <ng-container *ngIf="data.file && data.file.type">
          <ng-container *ngIf="isImageFile(data.file.type); else pdfPreview">
            <img
              [src]="imageUrl"
              class="tw-m-auto tw-max-h-full tw-max-w-full tw-object-contain"
              alt=""
            />
          </ng-container>
          <ng-template #pdfPreview>
            <ng-container
              *ngIf="isSupportedFileType(data.file.type) && !isAndroidMobile; else unsupportedFile"
            >
              <iframe
                [src]="pdfUrl"
                class="tw-h-full tw-w-full tw-rounded-xl tw-border-none"
              ></iframe>
            </ng-container>
            <ng-template #unsupportedFile>
              <p>{{ "filePreviewNotAvailable" | i18n }}</p>
            </ng-template>
          </ng-template>
        </ng-container>
        <ng-container *ngIf="!data.file || !data.file.type">
          <p>{{ "fileDataNotAvailable" | i18n }}</p>
        </ng-container>
      </ng-template>
    </ng-template>
  </div>
</ng-template>

<ng-container *ngIf="hasContainer; else noContainer">
  <div
    class="tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-4 tw-rounded-xl tw-bg-dt-surface-card tw-px-12 tw-py-8"
  >
    <span class="tw-text-2xl xs:tw-text-lg">{{ "filePreview" | i18n }}</span>
    <div class="!tw-flex tw-h-full tw-w-full">
      <ng-container *ngTemplateOutlet="filePreviewTemplate"></ng-container>
    </div>
  </div>
</ng-container>

<ng-template #noContainer>
  <ng-container *ngTemplateOutlet="filePreviewTemplate"></ng-container>
</ng-template>
